import {
  CcfBox,
  CcfCopilotSuggestionIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-copilot-voice-nbr.module.scss';
import Carousel from 'react-material-ui-carousel';
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
  ThumbDown,
  ThumbUp,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface CcfCopilotVoiceNbrProps {
  sliderItemsArr?: any;
}

/**
 * CcfCopilotVoiceNbr - used to display nbr response for voice interaction
 * @param props -?-CcfCopilotVoiceNbrProps
 * @example <CcfCopilotVoiceNbr />
 */
export function CcfCopilotVoiceNbr(props: CcfCopilotVoiceNbrProps) {
  const { sliderItemsArr } = props;
  const [isNbrLiked, setIsNbrLiked] = useState(false);
  const [isNbrDisliked, setIsNbrDisliked] = useState(false);

  /**
   * feedbackHandler - to like or dislike nbr response
   * @param props -?-isLiked
   * @example feedbackHandler()
   */
  const feedbackHandler = (feedback?: string) => {
    if (feedback === 'like') {
      setIsNbrLiked(true);
      setIsNbrDisliked(false);
    } else if (feedback === 'dislike') {
      setIsNbrLiked(false);
      setIsNbrDisliked(true);
    }
  };
  return (
    <Carousel
      autoPlay={false}
      indicators={false}
      animation="slide"
      navButtonsAlwaysVisible={true}
      className={styles.carousel}
      fullHeightHover={false}
      NextIcon={<ArrowForwardIosOutlined />}
      PrevIcon={<ArrowBackIosOutlined />}
      navButtonsProps={{
        style: {
          backgroundColor: '#fff',
          // borderRadius: 0,
          color: 'rgba(0, 0, 0, 0.54',
          margin: '0px 25px',
        },
      }}
      navButtonsWrapperProps={{
        style: {
          bottom: '0',
          top: '0',
          height: '40px',
        },
      }}
    >
      {sliderItemsArr?.map((sliderItem: any, i: any) => (
        <CcfBox className={styles.suggestionCard}>
          <CcfCopilotSuggestionIcon className={styles.cardIcon} />
          <CcfTypography className={styles.suggestionTxt}>
            {sliderItem}
          </CcfTypography>
          <CcfBox key={i} className={styles.feedbackBlock}>
            <IconButton onClick={() => feedbackHandler('like')}>
              <ThumbUp
                className={
                  !isNbrLiked ? styles.feedbackIcon : styles.feedbackLikeIcon
                }
              />
            </IconButton>
            <IconButton onClick={() => feedbackHandler('dislike')}>
              <ThumbDown
                className={
                  !isNbrDisliked ? styles.feedbackIcon : styles.feedbackLikeIcon
                }
              />
            </IconButton>
          </CcfBox>
        </CcfBox>
      ))}
    </Carousel>
  );
}

export default CcfCopilotVoiceNbr;
